import { render, staticRenderFns } from "./EmailViewGlobal.vue?vue&type=template&id=5f917b31&scoped=true&"
import script from "./EmailViewGlobal.vue?vue&type=script&lang=js&"
export * from "./EmailViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f917b31",
  null
  
)

export default component.exports